import React, { useState, useEffect } from 'react';
import './index.css';
//import App from './App';
//import reportWebVitals from './reportWebVitals';
//import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';

//import ResponsiveAppBar from './AppBar';
//import GetCurrencies from './GetCurrencies';
import ForexConverter from './ForexConverter';
import CurrencyConverter from './CurrencyConverter';
//import {conversionOptions, basisOptions, monthOptions } from './options';
import Circular from './Spinners';

//import axios from 'axios';

// SEO: h1 is visually hidden but fully readable by crawlers and screen readers.
// display:none / visibility:hidden hides content from crawlers — clip-pattern does not.
const SEO_H1 = React.memo(() => {
    return (
        <h1 style={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            padding: 0,
            margin: '-1px',
            overflow: 'hidden',
            clip: 'rect(0,0,0,0)',
            whiteSpace: 'nowrap',
            border: 0,
        }}>
            FxFORTAX &mdash; Foreign Exchange Gain/Loss Calculator for Australian Tax
        </h1>
    );
});

export default function Content() {

    const [data, setData] = useState(null);

    const fetchData = async () => {
        let currencyOptions = [];
        let defaultValue = 0;
        let URL = 'api/currencies';
        if (process.env.NODE_ENV === 'development') {
            URL = 'http://localhost:8081/api/currencies';
        }
        const response = await fetch(URL);
        const jsonData = await response.json();
        for (let i = 0; i < jsonData.length; i++) {
            currencyOptions.push({ value: jsonData[i], label: jsonData[i] })
            if (jsonData[i] === 'AUD') {
                defaultValue = i;
            }
        }

        setData({
            currencyOptions: currencyOptions,
            defaultValue: defaultValue,
        });
        //console.log(data);
    }
    useEffect(() => {
        fetchData();
    }, []);

    return (
        <React.Fragment>
            <SEO_H1 />
            <input id="result-copy" type="hidden" value=""></input>
            <input id="ob-copy" type="hidden" value=""></input>
            {data ? (
                <Box sx={{ flexGrow: 1, pb: 8 }}>
                    <Grid container spacing={2}>
                        <CurrencyConverter currOptions={data.currencyOptions} defaultValue={data.defaultValue} />
                    </Grid>
                    <Grid item xs={12} >
                        <Divider sx={{ mt: 2, bgcolor: 'lightgray'}}></Divider>
                    </Grid>
                    <Grid container spacing={2}>
                        <ForexConverter currOptions={data.currencyOptions} defaultValue={data.defaultValue} />
                    </Grid>
                </Box>
            ) : (
                <Circular />
            )}
        </React.Fragment>
    )
};
